 <template>
  <div class="info-region-container">
    <div class="all-content-container" v-allow="'0604'" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>设备位置配置</h4>
          <div>
            <el-button type="primary" class="adduser" @click="handleReturn">返回</el-button>
            <!-- <el-button type="primary" class="adduser" @click="handleBatch"
              >批量配置</el-button
            > -->
            <el-button type="primary" class="adduser" @click="handleAdd">添加</el-button>
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="大棚名称：" prop="groupId">
            <el-cascader v-model="groupIdArr" placeholder="请选择大棚名称" :show-all-levels="false" :options="groupArray" :props="optionProps" clearable @change="changeTreeItem"></el-cascader>
          </el-form-item>
          <el-form-item label="设备类型：" prop="type">
            <el-select v-model="searchForm.type" placeholder="请选择设备类型" clearable @change="handleSearch">
              <el-option label="数值" value="0"></el-option>
              <el-option label="视频" value="1"></el-option>
              <el-option label="开关" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="大棚名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备类型">
              <template slot-scope="scope">
                <p v-if="scope.row.type == 0">数值设备</p>
                <p v-if="scope.row.type == 1">视频设备</p>
                <p v-if="scope.row.type == 2">图片设备</p>
                <p v-if="scope.row.type == 3">开关设备</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="连线类型">
              <template slot-scope="scope">
                <p>{{ getLineTypeName(scope.row.lineType) }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="标注X">
              <template slot-scope="scope">
                <p>{{ scope.row.coordinateX }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="标注Y">
              <template slot-scope="scope">
                <p>{{ scope.row.coordinateY }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="大棚名称：" prop="groupIdArr">
                  <el-cascader expand-trigger="hover" v-model="ruleForm.groupIdArr" :options="groupArray" :props="optionProps" @change="groupChange2" placeholder="请选择大棚名称" collapse-tags clearable></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备类型：" prop="type">
                  <el-select v-model="ruleForm.type" placeholder="请选择设备类型" clearable @change="typeChange2">
                    <el-option label="数值" value="0"></el-option>
                    <el-option label="视频" value="1"></el-option>
                    <el-option label="开关" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备名称：" prop="eid">
                  <el-select v-model="ruleForm.eid" placeholder="请选择设备名称" clearable @change="deviceChange2">
                    <el-option v-for="(item, index) in deviceArray2" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="属性名称：" prop="attributeId">
                  <el-select v-model="ruleForm.attributeId" placeholder="请选择属性名称" clearable>
                    <el-option v-for="(item, index) in attributeArray2" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="连线类型：" prop="lineType">
                  <el-select v-model="ruleForm.lineType" placeholder="请选择连线类型" clearable>
                    <el-option v-for="(item, index) in lineTypeArrary" :label="item.name" :value="item.id" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <el-form-item label="标注X：" prop="coordinateX">
                  <el-input-number v-model="ruleForm.coordinateX" placeholder="请输入标注X" :precision="4" :step="1" :max="1" :min="0" size="small"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="标注Y：" prop="coordinateY">
                  <el-input-number v-model="ruleForm.coordinateY" placeholder="请输入标注Y" :precision="4" :step="1" :max="1" :min="0" size="small"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <img @click="handleOpenCoordinate" class="coordinate_icon" src="@/assets/coordinate.png" alt />
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="标注" :visible.sync="coordinateIsDialog" @close="handleCloseCoordinate()" width="1000px">
          <el-form :model="coordinateForm" ref="coordinateForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <div id="myDiv" class="myDiv">
                  <img id="myImg" src="@/assets/dp.png" style="width: 100%" @mousedown="getPosition" />
                </div>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseCoordinate()">取 消</el-button>
            <el-button type="primary" @click="handleSaveCoordinate()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        type: ''
      },
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: '',
        groupIdArr: [],
        groupId: '',
        type: '',
        eid: '',
        attributeId: '',
        lineType: '',
        coordinateX: '',
        coordinateY: '',
        orderNum: ''
      },
      rules: {
        // 添加、编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择大棚名称',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }
        ],
        eid: [
          {
            required: true,
            message: '请选择设备名称',
            trigger: 'change'
          }
        ],
        attributeId: [
          {
            required: true,
            message: '请选择属性名称',
            trigger: 'change'
          }
        ],
        lineType: [
          {
            required: true,
            message: '请选择连线类型',
            trigger: 'change'
          }
        ],
        coordinateX: [
          {
            required: true,
            message: '请输入标注X',
            trigger: 'blur'
          }
        ],
        coordinateY: [
          {
            required: true,
            message: '请输入标注Y',
            trigger: 'blur'
          }
        ],
        orderNum: [
          {
            required: true,
            message: '请输入排序号',
            trigger: 'blur'
          }
        ]
      },
      addEditTitle: '添加设备位置配置', // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      groupArray: [], // 大棚名称数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      },
      deviceArray2: [], // 设备数组
      attributeArray2: [], // 属性数组
      coordinateForm: {
        id: 0,
        code: '0',
        coordinateX: '',
        coordinateY: ''
      },
      coordinatePointArray: [], // 标注点集合
      coordinateIsDialog: false, // 标注弹窗是否显示
      lineTypeArrary: [
        { id: -1, name: '无' },
        { id: 0, name: '上直' },
        { id: 1, name: '下直' },
        { id: 2, name: '左直' },
        { id: 3, name: '右直' },
        { id: 4, name: '左上斜' },
        { id: 5, name: '左下斜' },
        { id: 6, name: '右上斜' },
        { id: 7, name: '右下斜' },
        { id: 8, name: '上直-左上斜' },
        { id: 9, name: '上直-右上斜' },
        { id: 10, name: '下直-左下斜' },
        { id: 11, name: '下直-右下斜' },
        { id: 12, name: '左直-左上斜' },
        { id: 13, name: '左直-左下斜' },
        { id: 14, name: '右直-右上斜' },
        { id: 15, name: '右直-右下斜' },
        { id: 16, name: '左上斜-上直' },
        { id: 17, name: '左上斜-左直' },
        { id: 18, name: '左下斜-左直' },
        { id: 19, name: '左下斜-下直' },
        { id: 20, name: '右上斜-上直' },
        { id: 21, name: '右上斜-右直' },
        { id: 22, name: '右下斜-右直' },
        { id: 23, name: '右下斜-下直' }
      ],
      devicePositionArray: [] // 设备位置数组
    }
  },
  created() {
    // 查询
    this.getList()

    // 获取分组列表
    this.getGroupList()
  },
  methods: {
    // 获取连线类型名称
    getLineTypeName(lineType) {
      let lineTypeName = ''
      this.lineTypeArrary.forEach((val) => {
        if (val.id == lineType) {
          lineTypeName = val.name
          return
        }
      })

      return lineTypeName
    },
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: '',
        type: ''
      }
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    // 分页获取列表
    getList() {
      this.loading = true
      this.$api.device.getObjDevicePositionList(this.searchForm).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.device.delObjDevicePosition(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true
      this.addEditTitle = '编辑设备位置配置'
      this.ruleForm.id = row.id

      // 获取详情
      this.$api.device.getObjDevicePosition({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.groupIdArr = [this.getParentGroupId(res.data.groupId), res.data.groupId]
          res.data.type = res.data.type != undefined ? res.data.type.toString() : ''
          this.ruleForm = res.data

          this.getDeviceList2()
          this.getAttributeList2()
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true
      this.addEditTitle = '添加设备位置配置'
      this.ruleForm.id = ''
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$api.device.saveObjDevicePosition(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 分组下拉
    changeTreeItem(val) {
      if (val && val.length == 2) {
        this.searchForm.groupId = val[val.length - 1]
      } else {
        this.searchForm.groupId = ''
        this.groupIdArr = []
      }
      this.handleSearch()
    },
    // 大棚下拉切换2
    groupChange2() {
      // 清空
      this.ruleForm.type = ''
      this.ruleForm.eid = ''
      this.ruleForm.attributeId = ''

      this.deviceArray2 = []
      this.attributeArray2 = []

      this.devicePositionArray = []

      // 不是二级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        this.ruleForm.groupId = ''
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map((item) => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 类型下拉切换
    typeChange2() {
      // 清空
      this.ruleForm.eid = ''
      this.ruleForm.attributeId = ''
      this.deviceArray2 = []
      this.attributeArray2 = []

      // 获取设备列表
      this.getDeviceList2()
    },
    // 设备下拉切换
    deviceChange2() {
      // 清空
      this.ruleForm.attributeId = ''
      this.attributeArray2 = []

      // 获取属性列表
      this.getAttributeList2()
    },
    // 获取设备列表
    getDeviceList2() {
      this.deviceArray2 = []
      if (this.ruleForm.type === '' || this.ruleForm.groupId === '') {
        return
      }

      if (this.ruleForm.type == 0) {
        // 数值设备
        this.$api.device.getNumericalsByGroupId({ groupId: this.ruleForm.groupId }).then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.ruleForm.type == 1) {
        // 视频设备
        this.$api.device.getVideosByGroupId({ id: this.ruleForm.groupId }).then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.ruleForm.type == 3) {
        // 开关设备
        this.$api.device.getSwitchsByGroupId({ id: this.ruleForm.groupId }).then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.deviceArray2.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      }
    },
    // 获取属性列表
    getAttributeList2() {
      this.attributeArray2 = []
      if (this.ruleForm.type === '' || this.ruleForm.type === '4' || this.ruleForm.eid === '') {
        return
      }

      this.$api.device
        .getDeviceAttributes({
          type: this.ruleForm.type,
          eid: this.ruleForm.eid
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              this.attributeArray2.push({
                id: val.id,
                name: val.cname,
                image: val.image
              })
            })
          }
        })
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: 'deviceManagement',
        query: {
          currentShow: 'second',
          currentShow1: 'first'
        }
      })
    },
    // 批量配置
    handleBatch() {
      this.$router.push({
        name: 'deviceGroupPositionBatch',
        query: {}
      })
    },
    // 关闭标注弹窗
    handleCloseCoordinate() {
      // 移除旧标注
      this.removeMarker(this.coordinateForm.id)
      this.coordinatePointArray.forEach((val) => {
        this.removeMarker(val)
      })
      this.coordinateIsDialog = false
    },
    // 获取属性名称
    getAttributeName(id) {
      let name = ''
      this.attributeArray2.forEach((val) => {
        if (id == val.id) {
          name = val.name
          return
        }
      })

      return name
    },
    // 获取属性图片
    getAttributeImage(id) {
      let image = ''
      this.attributeArray2.forEach((val) => {
        if (id == val.id) {
          image = val.image
          return
        }
      })

      return image
    },
    // 打开标注弹窗
    handleOpenCoordinate() {
      if (this.ruleForm.attributeId == '') {
        this.$message({
          type: 'error',
          message: '请先选择属性名称'
        })
        return
      }

      this.coordinateIsDialog = true
      this.coordinateForm.id = this.ruleForm.id != '' ? this.ruleForm.id : 0
      this.coordinateForm.code = this.getAttributeName(this.ruleForm.attributeId)
      this.coordinateForm.coordinateX = this.ruleForm.coordinateX
      this.coordinateForm.coordinateY = this.ruleForm.coordinateY
      this.coordinateForm.image = this.getAttributeImage(this.ruleForm.attributeId)

      setTimeout(() => {
        this.createMarker(this.coordinateForm.id, this.coordinateForm.coordinateX, this.coordinateForm.coordinateY, this.coordinateForm.code, this.coordinateForm.image)

        // 获取设备位置列表
        this.getDevicePositionList()
      }, 500)
    },
    // 获取设备位置列表
    getDevicePositionList() {
      if (this.ruleForm.groupId === '') {
        return
      }

      this.$api.device
        .getObjDevicePositions({
          id: this.ruleForm.groupId
        })
        .then((res) => {
          if (res.code == 200) {
            res.data.forEach((val) => {
              if (val.id != this.coordinateForm.id) {
                this.createMarker(val.id, val.coordinateX, val.coordinateY, val.attributeName, val.image)

                this.coordinatePointArray.push(val.id)
              }
            })
          }
        })
    },
    // 保存标注
    handleSaveCoordinate() {
      this.ruleForm.coordinateX = this.coordinateForm.coordinateX
      this.ruleForm.coordinateY = this.coordinateForm.coordinateY
      this.handleCloseCoordinate()
    },
    // 获取标注位置
    getPosition(e) {
      e = e || window.event

      // 判断是否是左键点击
      if (e.button === 0) {
        // 标注
        var x = e.offsetX || e.layerX
        var y = e.offsetY || e.layerY

        // 获取图片比例标注
        var myImg = document.querySelector('#myImg')
        var currWidth = myImg.clientWidth
        var currHeight = myImg.clientHeight
        var ProportionWidthInImg = x / currWidth
        var ProportionHeightInImg = y / currHeight

        // 移除旧标注
        this.removeMarker(this.coordinateForm.id)

        // 创建新标注
        this.createMarker(this.coordinateForm.id, ProportionWidthInImg, ProportionHeightInImg, this.coordinateForm.code, this.coordinateForm.image)

        // 更新标注信息
        this.coordinateForm.coordinateX = ProportionWidthInImg
        this.coordinateForm.coordinateY = ProportionHeightInImg
      }
    },
    // 移除标注
    removeMarker(id) {
      // 移除图标
      var img = document.getElementById('img' + id)
      if (img) {
        document.getElementById('myDiv').removeChild(img)
      }

      // 移除文字
      var span = document.getElementById('span' + id)
      if (span) {
        document.getElementById('myDiv').removeChild(span)
      }
    },
    // 创建标注
    createMarker(id, ProportionWidthInImg, ProportionHeightInImg, code, image) {
      if (!ProportionWidthInImg || !ProportionHeightInImg || ProportionWidthInImg === '' || ProportionHeightInImg === '') {
        return
      }

      // 获取图片宽高
      var myImg = document.querySelector('#myImg')
      var currWidth = myImg.clientWidth
      var currHeight = myImg.clientHeight

      // 根据比例标注计算实际标注，再加上点位半径
      var x = ProportionWidthInImg * currWidth + document.getElementById('myImg').offsetLeft - 30 / 2
      var y = ProportionHeightInImg * currHeight + document.getElementById('myImg').offsetTop - 30 / 2

      // 点位样式
      var img = document.createElement('img')
      img.id = 'img' + id
      img.style.width = '30px'
      img.style.left = x + 'px'
      img.style.top = y + 'px'
      img.style.position = 'absolute'
      img.style.zIndex = '999'
      img.src = image

      // 加载点位到图片上
      document.getElementById('myDiv').appendChild(img)

      // 文字样式
      var span = document.createElement('span')
      span.id = 'span' + id
      span.textContent = code
      span.style.left = x + 30 + 'px'
      span.style.top = y + 6 + 'px'
      span.style.position = 'absolute'
      span.style.zIndex = '1000'
      span.style.color = '#39fffb'
      span.style.fontSize = '15px'

      // 加载文字到图片上
      document.getElementById('myDiv').appendChild(span)
    }
  }
}
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }

  .coordinate_icon {
    width: 30px;
    height: 30px;
    margin-left: 20px;
    cursor: pointer;
  }
}

.myDiv {
  background-color: #021031;
}
</style>